import type { FarmUserType } from "@/types/farm-type";
import { createContext, type Dispatch, type SetStateAction } from "react";

export const FarmContext = createContext<{
    farm: FarmUserType[] | null;
    setFarm: Dispatch<SetStateAction<FarmUserType[] | null>>;
}>({
    farm: null,
    setFarm: () => null,
});
